import PropTypes from 'prop-types';
import React from 'react';
import { useParams } from 'react-router-dom';

import AdminBrowseCategoriesListPage from 'app/components/admin/browse/categories/AdminBrowseCategoriesListPage';

export function AdminBrowseCategoriesListPageRoute({ basePageRoute }) {
  const { topLevelCategoryId } = useParams();

  return <AdminBrowseCategoriesListPage basePageRoute={basePageRoute} topLevelCategoryId={topLevelCategoryId} />;
}

AdminBrowseCategoriesListPageRoute.propTypes = {
  basePageRoute: PropTypes.string.isRequired
};

export default AdminBrowseCategoriesListPageRoute;
